import axios from 'axios'

export default  {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    find({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/supply-chains/purchase-orders/${id}`)
          .then(res => {
            resolve(res.data.data.purchaseOrder)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    search({commit}, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/supply-chains/purchase-orders/search', {
            params
          })
          .then(res => {
            resolve(res.data.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    create({commit}, purchaseOrderForm) {
      return new Promise((resolve, reject) => {
        axios
          .post('/supply-chains/purchase-orders', purchaseOrderForm, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(res => {
            resolve(res.data.data.purchaseOrder)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    update({commit}, purchaseOrderForm) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/supply-chains/purchase-orders/${purchaseOrderForm.get('id')}`, purchaseOrderForm, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(res => {
            resolve(res.data.data.purchaseOrder)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    delete({commit}, purchaseOrderId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/supply-chains/purchase-orders/${purchaseOrderId}`)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    restore({commit}, purchaseOrderId) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/supply-chains/purchase-orders/${purchaseOrderId}/restore`)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    changeStatus({commit}, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/supply-chains/purchase-orders/${params.id}/change-status`, params)
          .then(res => {
            resolve(res.data.data.purchaseOrder)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    createApproval({commit}, approvalData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/supply-chains/purchase-orders/${approvalData.purchase_order_id}/approvals`, approvalData)
          .then(res => {
            resolve(res.data.data.purchaseOrder)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    verify({commit}, verifyData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/supply-chains/purchase-orders/${verifyData.id}/verify`, verifyData)
          .then(res => {
            resolve(res.data.data.status)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    downloadPdf({commit}, {projectBillingId}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/finances/accounts-receivables/${projectBillingId}/download-pdf`, {
            responseType: 'blob',
          })
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
